<template>
  <Box :class="classes" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)">
    <slot name="default"></slot>
  </Box>
</template>

<script>

export default {
  props: {
    backgroundColor: {
      type: String
    },
    borderColor: {
      type: String
    },
    justifyContent: {
      type: String
    },
    alignContent: {
      type: String
    },
    alignItems: {
      type: String
    },
    flexDirection: {
      type: String
    },
    flexWrap: {
      type: String
    }
  },
  computed: {
    classes () {
      let classes = [
        'web-flexbox-layout'
      ]

      return classes.join(' ')
    }
  },
  watch: {
    borderColor: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.borderColor = to
        })
      }
    },
    backgroundColor: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.backgroundColor = to
        })
      }
    },
    justifyContent: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.justifyContent = to
        })
      }
    },
    alignContent: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.alignContent = to
        })
      }
    },
    alignItems: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.alignItems = to
        })
      }
    },
    flexDirection: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.flexDirection = to
        })
      }
    },
    flexWrap: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.flexWrap = to
        })
      }
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-flexbox-layout {
    display: flex;
  }
}

</style>